import React from 'react'
import { Text, View } from 'react-native';
import { Link } from './routing';

const Index = () => {
   return (
      <View>
        <View>
          <Link to='/lesson1'><Text>Lesson 1</Text></Link>
          <Link to='/grammar_test'><Text>Grammar test</Text></Link>
        </View>
      </View>
   )
}
export default Index
